module.exports = __webpack_public_path__ + "img/sprinkle-1.62b85bed.webp";